import { GamePlayConfig, QueryResponse } from 'shared-services'
import {
  DefenderDeclarationGame,
  defenderDeclarationGameNull,
} from '../models/defender-declaration-game'
import { GetGameErrorCode } from '../error-codes/get-game.error-code'
import { DefenderDeclarationGameDto } from '../dtos/defender-declaration-game.dto'
import { defenderDeclarationGameMapper } from '../mappers/defender-declaration-game.mapper'
import { GamePlayGameId } from '../models/game-play-game-id'
import { DefendOptionType } from '../types/defend-option-type'

export class DefenderDeclarationService {
  public constructor(private readonly gamePlayConfig: GamePlayConfig) {}

  public async getDefenderDeclarationGame(
    gamePlayGameId: GamePlayGameId,
  ): Promise<QueryResponse<DefenderDeclarationGame, GetGameErrorCode>> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId
    const query = `gamePlayId=${gamePlayId}&gameId=${gameId}`

    const response = await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/defender-declaration/v1/defender-declaration-game?${query}`,
      {
        credentials: 'include',
      },
    )

    const defenderDeclarationGameResponse =
      (await response.json()) as QueryResponse<
        DefenderDeclarationGameDto,
        GetGameErrorCode
      >

    const result = defenderDeclarationGameResponse.isSuccessful
      ? defenderDeclarationGameMapper.mapToDefenderDeclarationGame(
          defenderDeclarationGameResponse.result,
        )
      : defenderDeclarationGameNull

    return {
      errorCode: defenderDeclarationGameResponse.errorCode,
      errorCodes: defenderDeclarationGameResponse.errorCodes,
      isSuccessful: defenderDeclarationGameResponse.isSuccessful,
      result,
    }
  }

  public async declareDefendOption(
    gamePlayGameId: GamePlayGameId,
    defendOption: DefendOptionType,
  ): Promise<void> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId

    const body = {
      gamePlayId,
      gameId,
      defendOption,
    }

    await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/defender-declaration/v1/declare-defend-option`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  }
}
